module.exports = __webpack_public_path__ + "static/img/training_system_hy_s4.cea1a119.png";